import { Component, OnInit, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import {default as _} from 'lodash';
import { format } from 'date-fns';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { MessageService } from 'primeng/api';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { CaisServiceService } from '../../../../Pages/cais/cais-service.service';

import $ from 'jquery';
import { DialogModule } from 'primeng/dialog';
import { LowerCasePipe, NgClass, CommonModule} from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TidGeneratorComponent } from '../../cais-tid/tid-generator/tid-generator.component';
import { ToastModule } from 'primeng/toast';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
    selector: 'app-add-edit-view-form',
    imports: [DialogModule, CommonModule, FormsModule, NgClass, DatePickerModule, Select, TableModule,
        ButtonModule, TidGeneratorComponent, LowerCasePipe, ToastModule],
    templateUrl: './add-edit-view-form.component.html',
    styleUrls: ['./add-edit-view-form.component.scss']
})

export class AddEditViewFormComponent implements OnInit, OnDestroy {
  @Input() rowData: any;
  @Input() actionType!: string;
  @Input() index!: number;
  @Input() screenType!: string;
  @Input() addScreenNegotiatedFields!: Array<string>;
  @Input() editScreenNegotiatedFields!: Array<string>;
  @Input() viewScreenNegotiatedFields!: Array<string>;
  @Input() addressColumns: any = [];
  @Input() addressData: any = [];
  @Input() addressDataDetails: any = [];
  @Input() screenData: any = [];
  @Input() yearField: any = [];
  @Input() showTIDGeneratorBtn: boolean = false;
  @Input() showTIDUpdateBtn: boolean = false;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addScreenRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() editScreenRow: EventEmitter<any> = new EventEmitter<any>();
  Add: boolean = false;
  Edit: boolean = false;
  View: boolean = false;
  isClickedOnce: boolean = false;
  tblNorecordmsg: string = '';
  selectedRow: any = [];
  AddressDetails: any = [];
  screenDetails: any;
  storeBirthYear: any = [];

  constructor(public emitterService: EmitterService, 
    public messageService: MessageService, 
    public ConstantService: ConstantService,
    public caisServiceService: CaisServiceService,
    public constantService: ConstantService) {
      this.tblNorecordmsg = ConstantService.NO_RECORDFOUND_MSG;
  }

  ngOnInit() {
    this.isClickedOnce = false;

    this.selectedRow = [];
    this.selectedRow = (this.rowData);

    this.AddressDetails = this.addressData; // Address Data
    this.screenDetails = this.screenData; // Screen Data

    if (this.actionType === 'View') {
      this.View = true;
      /* Mask Birth Date Field */
      if(this.yearField.length > 0) {
        this.maskYear();
      }
    } else if (this.actionType === 'Edit') {
      this.Edit = true;
      /* Masking Birth of Year */
      if(this.yearField.length > 0) {
        this.maskYear();
      }
      this.toggleEditableFieldDisability(); // Conditions for multiEdit Disability
    } else if (this.actionType === 'Add') {
      this.Add = true;
      /* Masking Birth of Year */
      if(this.yearField.length > 0) {
        this.maskYear();
      }
      this.toggleEditableFieldDisability(); // Conditions for multiEdit Disability
    }
    
  }

  isDisabled(rowDetail : any) {
    if(_.includes(['Natural-Person', 'Legal-Entity', 'CAIS-TID'], this.screenType) && _.includes(['foreignTIDCountryCd'], rowDetail.field_Name)) {
      let TIDType = this.screenDetails.find((row: { field_Name: string; }) => row.field_Name === 'tidType');
      let foreignTIDType = this.screenDetails.find((row: { field_Name: string; }) => row.field_Name === 'foreignTIDType');
      return ((TIDType.value && _.includes(['FOREIGN'], TIDType.value) && foreignTIDType.value && _.includes(this.caisServiceService.foreignTIDTypes, foreignTIDType.value)) ? false : true);
    } else if(_.includes(['Natural-Person', 'Legal-Entity', 'CAIS-TID'], this.screenType) && _.includes(['foreignTIDType'], rowDetail.field_Name)) {
      let TIDType = this.screenDetails.find((row: { field_Name: string; }) => row.field_Name === 'tidType');
      return !_.includes(['FOREIGN'], TIDType.value);
    } else if(_.includes(['CAIS-TID'], this.screenType) && _.includes(['replacingForeignTIDCountryCd'], rowDetail.field_Name)) {
      let replacedByTIDType = this.screenDetails.find((row: { field_Name: string; }) => row.field_Name === 'replacedByTIDType');
      let replacingForeignTIDType = this.screenDetails.find((row: { field_Name: string; }) => row.field_Name === 'replacingForeignTIDType');
      return ((replacedByTIDType.value && _.includes(['FOREIGN'], replacedByTIDType.value) && replacingForeignTIDType.value && _.includes(this.caisServiceService.foreignTIDTypes, replacingForeignTIDType.value)) ? false : true);
    } else if(_.includes(['CAIS-TID'], this.screenType) && _.includes(['replacingForeignTIDType'], rowDetail.field_Name)) {
      let replacedByTIDType = this.screenDetails.find((row: { field_Name: string; }) => row.field_Name === 'replacedByTIDType');
      return !_.includes(['FOREIGN'], replacedByTIDType.value);
    } else {
      return rowDetail.isDisable;
    }
  }

  /* Function Event on changing Dropdownbox value */
  onChangeSelectionBox(fieldDetail: { field_Name: any; value: string; }) {
    if((_.includes(['Natural-Person', 'Legal-Entity', 'CAIS-TID'], this.screenType))) {
      if(_.includes(['tidType'], fieldDetail.field_Name) && fieldDetail.value!=='FOREIGN') {
        let foreignTIDTypeIndex = this.screenDetails.findIndex((row: { field_Name: string; }) => row.field_Name === 'foreignTIDType');
        let foreignTIDCountryIndex = this.screenDetails.findIndex((row: { field_Name: string; }) => row.field_Name === 'foreignTIDCountryCd');
        this.screenDetails[foreignTIDTypeIndex]['value'] = this.screenDetails[foreignTIDCountryIndex]['value'] = null;
      }
      if (_.includes(['replacedByTIDType'], fieldDetail.field_Name) && fieldDetail.value!=='FOREIGN') {
        let replacedForeignTIDTypeIndex = this.screenDetails.findIndex((row: { field_Name: string; }) => row.field_Name === 'replacingForeignTIDType');
        let replacedForeignTIDCountryIndex = this.screenDetails.findIndex((row: { field_Name: string; }) => row.field_Name === 'replacingForeignTIDCountryCd');
        this.screenDetails[replacedForeignTIDTypeIndex]['value'] = this.screenDetails[replacedForeignTIDCountryIndex]['value'] = null;
      }
      if (_.includes(['foreignTIDType'], fieldDetail.field_Name) && fieldDetail.value==='LEI') {
        let foreignTIDCountryIndex = this.screenDetails.findIndex((row: { field_Name: string; }) => row.field_Name === 'foreignTIDCountryCd');
        this.screenDetails[foreignTIDCountryIndex]['value'] = null;
      }
      if (_.includes(['replacingForeignTIDType'], fieldDetail.field_Name) && fieldDetail.value==='LEI') {
        let replacedForeignTIDCountryIndex = this.screenDetails.findIndex((row: { field_Name: string; }) => row.field_Name === 'replacingForeignTIDCountryCd');
        this.screenDetails[replacedForeignTIDCountryIndex]['value'] = null;
      }
    }
  }

  isEmptyObject(ObjectParams: {[key: string]: any}) {
    if(Object.keys(ObjectParams).length > 0) {
      for (let key in ObjectParams) {
        if (key!=='errorFields' && (ObjectParams[key]!==null && ObjectParams[key]!=="")) {
          return false;
        }
      }
    }
    return true;
  }

  addNewRecord() {
    this.isClickedOnce = true;

    // Check the mandatory requirement for Dependent fields
    this.caisServiceService.checkDependentFieldRequirement([], this.screenDetails, [{baseField: 'TID Type', baseFieldValues: this.caisServiceService.TIDTypes, dependentField: 'Foreign TID Type'}, {baseField: 'Foreign TID Type', baseFieldValues: this.caisServiceService.foreignTIDTypes, dependentField: 'Foreign TID Country'}, {baseField: 'End Replacing Foreign TID Type', baseFieldValues: this.caisServiceService.foreignTIDTypes, dependentField: 'Replacing Foreign TID Country'}]);

    this.validateFields(this.screenDetails); // Field Validation
    /* Address Validation */
      if(this.AddressDetails.length > 0) {
        let addressFields = this.addressDataDetails;
        for(let i=0;i<this.AddressDetails.length;i++) {
          if(!this.isEmptyObject(this.AddressDetails[i])) {
            /* Previous Empty Address Fields Validation */
              this.previousEmptyAddressFieldValidation(i, this.AddressDetails, addressFields);
            /* End of Previous Empty Address Fields Validation */
            this.validateAddressFields(this.AddressDetails[i], addressFields); // Validating FDID Address Fields
          } else {
            delete this.AddressDetails[i].errorFields;
          }
        }
      }
    /* End of Address Validation */
    /* Stop Page submission while found Field error */
    if(_.filter(this.screenDetails, fieldDetail => fieldDetail.error).length > 0 || _.filter(this.AddressDetails, AddressfieldDetail => AddressfieldDetail.errorFields && Object.keys(AddressfieldDetail['errorFields']).length > 0).length > 0) {
      this.isClickedOnce = false;
      return false;
    }
    this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_WARN, summary: this.ConstantService.MESSAGE_SUMMARY_INFO, detail: 'Please wait while we insert new record...' });

    const responseData: { [key: string]: any } = {};;
    responseData['screenData'] = this.screenDetails;
    if(this.AddressDetails.length > 0) {
      responseData['addressData'] = this.AddressDetails;
    }

    this.addScreenRow.emit(responseData);

    return true;
  }

  editRecord() {
    this.isClickedOnce = true;

    // Check the mandatory requirement for Dependent fields
    this.caisServiceService.checkDependentFieldRequirement([], this.screenDetails, [{baseField: 'TID Type', baseFieldValues: this.caisServiceService.TIDTypes, dependentField: 'Foreign TID Type'}, {baseField: 'Foreign TID Type', baseFieldValues: this.caisServiceService.foreignTIDTypes, dependentField: 'Foreign TID Country'}, {baseField: 'End Replacing Foreign TID Type', baseFieldValues: this.caisServiceService.foreignTIDTypes, dependentField: 'Replacing Foreign TID Country'}]);

    this.validateFields(this.screenDetails); // Field Validation

    /* Address Validation */
      if(this.AddressDetails.length > 0) {
        let addressFields = this.addressDataDetails;
        for(let i=0;i<this.AddressDetails.length;i++) {
          if(!this.isEmptyObject(this.AddressDetails[i])) {
            /* Previous Empty Address Fields Validation */
              this.previousEmptyAddressFieldValidation(i, this.AddressDetails, addressFields);
            /* End of Previous Empty Address Fields Validation */
            this.validateAddressFields(this.AddressDetails[i], addressFields); // Validating FDID Address Fields
          } else {
            delete this.AddressDetails[i].errorFields;
          }
        }
      }
    /* End of Address Validation */
    /* Stop Page submission while found Field error */
    if(_.filter(this.screenDetails, fieldDetail => fieldDetail.error).length > 0 || _.filter(this.AddressDetails, AddressfieldDetail => AddressfieldDetail.errorFields && Object.keys(AddressfieldDetail['errorFields']).length > 0).length > 0) {
      this.isClickedOnce = false;
      return false;
    }
    this.messageService.add({ severity: this.ConstantService.MESSAGE_SEVERITY_WARN, summary: this.ConstantService.MESSAGE_SUMMARY_INFO, detail: 'Please wait while we modify record...' });

    const responseData: { [key: string]: any } = {};
    responseData['screenData'] = this.screenDetails;
    if(this.AddressDetails.length > 0) {
      responseData['addressData'] = this.AddressDetails;
    }
    this.editScreenRow.emit(responseData);

    return true;
  }

  validateFields(screenFields: string | any[]) {
    if(screenFields.length > 0) {
      for(let i=0; i<screenFields.length; i++) {
        /* Required Field Validation */
        if(screenFields[i]["isrequired"]===true && screenFields[i]["isDisable"]!==true && (!screenFields[i]["value"] || screenFields[i]["value"]==="" || screenFields[i]["value"]===null)) {
          screenFields[i]["error"] = "Please enter required field";
          continue;
        } else {
          delete screenFields[i]["error"];
        }
        /* Alternative Field Validation */
        this.checkAlterNativeFormField(screenFields[i], screenFields as any[]);
        /* Field format Validation */
        if(screenFields[i]["value"] && screenFields[i]["regexpressions"] && screenFields[i]["regexpressions"].length > 0) {
          let validFieldFormat = false;
          for(let j=0; j<screenFields[i]["regexpressions"].length; j++) {
            if(new RegExp(screenFields[i]["regexpressions"][j]).test(screenFields[i]["value"])===true) {
              validFieldFormat = true;
              delete screenFields[i]["error"];
            }
          }
          if(validFieldFormat === false) {
            screenFields[i]["error"] = "Please enter valid format";
            continue;
          }
        }
      }
    }
  }

  validateAddressFields(dataObj: any, screenFields: string | any[]) {
    if(screenFields.length > 0) {
      if(!dataObj["errorFields"]) {
        dataObj["errorFields"] = [];
      }
      for(let i=0; i<screenFields.length; i++) {
        /* Required Field Validation */
        if(screenFields[i]["isrequired"]===true && screenFields[i]["isDisable"]!==true && (!dataObj[screenFields[i]['field_Name']] || dataObj[screenFields[i]['field_Name']]==="" || dataObj[screenFields[i]['field_Name']]===null)) {
          dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter required field";
          continue;
        } else if(screenFields[i]["isrequired"]===true && dataObj[screenFields[i]['field_Name']]) {
          delete dataObj["errorFields"][screenFields[i]['field_Name']];
        }
        /* Field format Validation */
        if(this.caisServiceService.checkRegexpressionValidity(dataObj, screenFields[i])) {
          let validFieldFormat = false;
          for(let j=0; j<screenFields[i]["regexpressions"].length; j++) {
            if(new RegExp(screenFields[i]["regexpressions"][j]).test(dataObj[screenFields[i]['field_Name']])===true) {
              validFieldFormat = true;
              delete dataObj["errorFields"][screenFields[i]['field_Name']];
            }
          }
          if(validFieldFormat === false) {
            dataObj["errorFields"][screenFields[i]['field_Name']] = "Please enter valid format";
            continue;
          }
        }

      }
    }
  }

  /* Check AlterNative Fields' values from All form Field-List */
  checkAlterNativeFormField(screenField: { [x: string]: any; }, AllScreenFields: any[]) {
    if(screenField["hasAlternativeField"]===true && screenField["isDisable"]!==true && (!screenField["value"] || screenField["value"]==="" || screenField["value"]===null)) {
      let hasAlternateValue = false;
      for(let k=0; k<screenField["alternativeFields"].length; k++) {
        let alternateField = AllScreenFields.filter((fieldRow: { field_Name: any; }) => fieldRow.field_Name===screenField["alternativeFields"][k]);
        if((alternateField[0]["value"] && alternateField[0]["value"]!==undefined)) {
          hasAlternateValue = true;
          break;
        }
      }
      if(!hasAlternateValue) {
        screenField["error"] = "Please enter " + screenField['field_Name'] + " OR " + screenField["alternativeFields"].join();
      } else {
        delete screenField["error"];
      }
    } else {
      delete screenField["error"];
    }
  }

  /* Previous Empty Address Fields Validation */
  previousEmptyAddressFieldValidation(currentIndex: number, addressDataObj: { [x: string]: any; }, addressFields: any) {
    if(currentIndex > 0) {
      for(let j=currentIndex; j>=0; j--) {
        if(this.isEmptyObject(addressDataObj[j])) {
          this.validateAddressFields(addressDataObj[j], addressFields); // Validating FDID Address Fields
        }
      }
    }
  }

  maskYear() {
    $(() => {
      let birthYears = (this.storeBirthYear && this.storeBirthYear.length > 0 ? this.storeBirthYear : []);
      $('.birthYear').each(function(index: string | number) {
        const yearOfBirthElement = $('#yearOfBirth');
        if(yearOfBirthElement.length > 0) {
        const yearOfBirthValue = yearOfBirthElement.val();

        if(yearOfBirthValue && yearOfBirthValue.toString().length > 3 && !yearOfBirthValue.toString().includes("*")) {
          birthYears[index] = (yearOfBirthValue.toString());
        }
        if(yearOfBirthValue && yearOfBirthValue.toString().length > 3) {
          const yearField = yearOfBirthValue.toString();
          const maskedValue = yearField.substring(0, yearField.toString().length-2) + '*'.repeat(2);
          $('#yearOfBirth').val(maskedValue);
        }
      }
      });
      this.storeBirthYear = birthYears;
    });
  }

  unMaskYear(eventValue: any) {
    $(() => {
      let birthYears = this.storeBirthYear;
      $('.birthYear').each(function(index: string | number) {
        const yearOfBirthElement = $('#yearOfBirth');
      if(yearOfBirthElement.length > 0){
        const yearOfBirthValue = yearOfBirthElement.val();
        if(yearOfBirthValue && yearOfBirthValue.toString().length > 3) {
          $('#yearOfBirth').val(birthYears[index]);
        }
      }
      });
    });
  }

  toggleEditableFieldDisability() {
    $(() => {
      $("input[data-multieditdisabled=true][ng-reflect-model!='']").prop('disabled', false);
      $("input[data-multieditdisabled=true][ng-reflect-model='']").prop('disabled', (($("input[data-multieditdisabled=true][ng-reflect-model='']").length === $('input[data-multieditdisabled=true]').length) ? false : true));

      const inputs = $("input[data-multieditdisabled=true]");
        inputs.on('keydown', function() {
          $("input[data-multieditdisabled=true][ng-reflect-model!='']").prop('disabled', false);
          if($("input[data-multieditdisabled=true][ng-reflect-model='']").length === $('input[data-multieditdisabled=true]').length) {
            $("input[data-multieditdisabled=true]").prop('disabled', false);
          } else {
            $("input[data-multieditdisabled=true][ng-reflect-model='']").prop('disabled', true);
          }
        });
        inputs.on('keyup', function() {
          $("input[data-multieditdisabled=true][ng-reflect-model!='']").prop('disabled', false);
          if($("input[data-multieditdisabled=true][ng-reflect-model='']").length === $('input[data-multieditdisabled=true]').length) {
            $("input[data-multieditdisabled=true]").prop('disabled', false);
          } else {
            $("input[data-multieditdisabled=true][ng-reflect-model='']").prop('disabled', true);
          }
        });

    });
  }

  getFormat(dateObj: any) {
    return (dateObj ? format(new Date(dateObj), 'yyyy-MM-dd') : '');
  }

  setTIDType(fieldName: any) {
    if(_.includes(['ein', 'lei'], fieldName)) {
      let EINIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "EIN");
      let LEIIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "LEI");
      let TIDTypeIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "TID Type");
      if((this.screenDetails[EINIndex]['value'] || this.screenDetails[LEIIndex]['value']) && !this.screenDetails[TIDTypeIndex]['value']) {
        this.screenDetails[TIDTypeIndex]['value'] = 'EIN';
        /* Generate TID Value automatically on creation of Legal Entity */
        this.AutoGenerateTID(this.screenDetails[EINIndex]['value'], fieldName);
      } else if(!this.screenDetails[EINIndex]['value'] && !this.screenDetails[LEIIndex]['value'] && this.screenDetails[TIDTypeIndex]['value']==='EIN') {
        this.screenDetails[TIDTypeIndex]['value'] = null;
      }
    }
  }

  AutoGenerateTID(elemValue: any, fieldName: any) {
    /* Auto TID Generation by EIN OR LEI Value when creating new Legal Entity */
    let EINIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "EIN");
    let LEIIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "LEI");
    let TIDTypeIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "TID Type");
    let TIDValueIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "TID Value");
    let ForeignTIDTypeIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "Foreign TID Type");

    if(_.includes(['ein', 'tidType'], fieldName) && this.screenDetails[TIDTypeIndex]['value'] === 'EIN') {

      if(this.screenDetails[EINIndex]["regexpressions"] && this.screenDetails[EINIndex]["regexpressions"].length > 0) {
        for(let j=0; j<this.screenDetails[EINIndex]["regexpressions"].length; j++) {
          if(new RegExp(this.screenDetails[EINIndex]["regexpressions"][j]).test(this.screenDetails[EINIndex]['value'])===true) {
            this.caisServiceService.TIDGenerator(this.screenDetails[EINIndex]['value']).subscribe({
              next: (res:any) => {
              let resultSet: any = res;
              this.screenDetails[TIDValueIndex]["value"] = (resultSet.tidValue ? resultSet.tidValue : "");
            }});
            break;
          }
        }
      }
    } else if(_.includes(['lei', 'tidType', 'foreignTIDType'], fieldName) && this.screenDetails[EINIndex] && !this.screenDetails[EINIndex]['value'] && this.screenDetails[LEIIndex] && this.screenDetails[LEIIndex]['value']!=='' && this.screenDetails[TIDTypeIndex]['value'] === 'FOREIGN' &&  this.screenDetails[ForeignTIDTypeIndex]['value'] === 'LEI') {
      this.caisServiceService.TIDGenerator(this.screenDetails[LEIIndex]['value']).subscribe({
        next: (res:any) => {
        let resultSet: any = res;
        this.screenDetails[TIDValueIndex]["value"] = (resultSet.tidValue ? resultSet.tidValue : "");
      }});
    }
  }
  openTIDGenratePopUp(field_Name:string){
    let ForeignTIDTypeIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "Foreign TID Type");
    let TIDValueIndex = this.screenDetails.findIndex((filterElem: { ui_Field_Name: string; }) => filterElem.ui_Field_Name === "TID Value");
    if(field_Name === "foreignTIDType" && this.screenDetails[ForeignTIDTypeIndex]['value'] !='LEI'){
      this.caisServiceService.isNaturalPersonForeignTIDGenerator = true;
      this.caisServiceService.isLegalEntityForeignTIDGenerator = false;
      this.caisServiceService.isDisplayTIDGenerator = true;  
      this.caisServiceService.emptyForeginTIDValue('NaturalPerson');
    }
    this.caisServiceService.currentNaturalPersonTIDValue.subscribe(value=>{
      this.screenDetails[TIDValueIndex]['value'] = value;
    })
}

  ngOnDestroy() {
  }

}